import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface StepItem {
  id: string;
  title: string;
}

export interface StepSummary {
  label: string;
  value?: string;
  status: 'completed' | 'active' | 'disabled';
}

export type StepState = 'completed' | 'active' | 'upcoming';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {
  @Input() steps: StepItem[] = [];
  @Input() currentStep: number = 0;
  @Input() stepData: { [stepId: string]: StepSummary } = {};
  @Input() allowClickNavigation: boolean = false;
  @Input() showSummary: boolean = true;

  @Output() stepClick = new EventEmitter<number>();

  getStepState(index: number): StepState {
    if (index < this.currentStep) return 'completed';
    if (index === this.currentStep) return 'active';
    return 'upcoming';
  }

  getConnectorState(index: number): 'completed' | 'upcoming' {
    return index - 1 < this.currentStep ? 'completed' : 'upcoming';
  }

  onStepClick(index: number): void {
    if (this.allowClickNavigation) {
      this.stepClick.emit(index);
    }
  }
}
